import { formatFilters } from "../helpers/csv";

/**
 * The filter line of the CSV header block, on paper. A printed page has no filter
 * controls on it - without this the sheet never says which project, location or period
 * the numbers are a view of, and a printout passed around a week later is unreadable.
 * Hidden on screen, where the controls themselves answer the question.
 */
export function PrintFilters({ filters }: { filters?: Record<string, unknown> }) {
  const text = formatFilters(filters);
  if (!text) return null;
  return <p className="glut-print-filters">Filters: {text}</p>;
}
